import React from "react";
import { Button } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

const BASE_URL = "https://lux.capital";

const urlByLocale = {
  privacy: {
    en: "/privacy/",
    br: "/privacidade/",
    es: "/privacidad/",
  },
  terms: {
    en: "/terms/",
    br: "/termos-de-uso/",
    es: "/condiciones-de-uso/",
  },
};

const OnboardingLinks = ({ locale = "en" }) => {
  const termsUrl = `${BASE_URL}${urlByLocale.terms[locale]}`;
  const privacyUrl = `${BASE_URL}${urlByLocale.privacy[locale]}`;
  return (
    <div style={{ marginTop: 32 }}>
      <Button fullWidth size="small" variant="text" style={{ marginTop: 16 }} href={termsUrl} target="_blank" rel="noopener noreferrer">
        <FormattedMessage id="app.termsAndConditions" />
      </Button>

      <Button fullWidth size="small" variant="text" style={{ marginTop: 16 }} href={privacyUrl} target="_blank" rel="noopener noreferrer">
        <FormattedMessage id="app.privacyPolicy" />
      </Button>
    </div>
  );
};

export default OnboardingLinks;
